/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardDialogController', DinghyEventBoardDialogController);

    DinghyEventBoardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', '$filter', 'DinghyEventBoard', 'Profile', 'DinghyBoard', '$http', 'Content'];

    function DinghyEventBoardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, $filter, DinghyEventBoard, Profile, DinghyBoard, $http, Content) {
        var $translate = $filter('translate');
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.dinghies = [];
        vm.allGodparents = [];
        vm.hadGodparent = vm.dinghyEvent.godparent != null;
        if (vm.dinghyEvent.id !== null) {
            vm.oldCanceled = vm.dinghyEvent.canceled;
            vm.oldName = vm.dinghyEvent.name;
            vm.oldFromDate = vm.dinghyEvent.fromDate;
            vm.oldUntilDate = vm.dinghyEvent.untilDate;
            vm.oldDescription = vm.dinghyEvent.description;
            vm.oldLocation = vm.dinghyEvent.location;
            vm.oldGodparent = vm.dinghyEvent.godparent;
        }
        $http.get('api/board/profiles/dinghy/').then(function(response) {
            vm.allGodparents = response.data;
        });
        $http.get('api/board/dinghy-events/default-mail').then(function(response) {
            vm.defaultMail = response.data.value;
        });
        if (vm.dinghyEvent.id === null) {
            $http.get('api/board/dinghy-events/home-location').then(function(response) {
                vm.dinghyEvent.location = response.data.value;
            });
        }

        vm.showBulkCreateOptions = false;
        vm.activeFromDate = null;
        vm.additionalFromDates = [];

        vm.checkFromDate = function () {
            // return true on invalid --> can't submit anyway
            return !vm.dinghyEvent.id || !vm.dinghyEvent.fromDate || vm.dinghyEvent.fromDate.getTime() === vm.oldFromDate.getTime() || (vm.oldCanceled && vm.dinghyEvent.canceled);
        }

        vm.checkUntilDate = function () {
            // return true on invalid --> can't submit anyway
            return !vm.dinghyEvent.id || !vm.dinghyEvent.untilDate || vm.dinghyEvent.untilDate.getTime() === vm.oldUntilDate.getTime() || (vm.oldCanceled && vm.dinghyEvent.canceled);
        }

        const priceTypes = ['regatta', 'training'];

        vm.typeChanged = typeChanged;
        vm.dateChanged = dateChanged;
        vm.hasPrices = hasPrices;
        vm.replaceYear = replaceYear;
        vm.loadAvailableDinghies = loadAvailableDinghies;
        vm.initBulkCreate = initBulkCreate;
        vm.removeSelectedDate = removeSelectedDate;
        vm.formIsDirty = formIsDirty;

        if(vm.dinghyEvent.id) {
            loadAvailableDinghies();
        }

        $timeout(function (){
            document.getElementById('field_type').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.dinghyEvent.name = vm.dinghyEvent.name.trim();
            vm.dinghyEvent.location = vm.dinghyEvent.location.trim();
            vm.isSaving = true;
            if (vm.dinghyEvent.id !== null) {
                DinghyEventBoard.update(vm.dinghyEvent, onSaveSuccess, onSaveError);
            } else {
                DinghyEventBoard.save({
                    'dinghyEvent': vm.dinghyEvent,
                    'additionalFromDates': vm.additionalFromDates
                }, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('askApp:dinghyEventUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.untilDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        function typeChanged () {
            setIdentifier();
            loadConditions();
            dateChanged();

            // convenient closed form expression to check for leisure or engagement
            vm.allowGuests = !hasPrices();
        }

        function setIdentifier () {
            vm.dinghyEvent.identifier = $translate('askApp.dinghyEvent.identifierType.' + vm.dinghyEvent.type);
        }

        function loadConditions () {
            Content.get({id : getConditionId()}, function (data){
                vm.dinghyEvent.conditions = data.text;
            });
        }

        function getConditionId () {
            switch (vm.dinghyEvent.type) {
                case 'leisure':
                    return 31;
                case 'regatta':
                    return 32;
                case 'training':
                    return 33;
                case 'engagement':
                    return 34;
                default:
                    throw new Error('unknown event type!');
            }
        }

        function loadAvailableDinghies() {
            if (vm.dinghyEvent.fromDate == null || vm.dinghyEvent.untilDate == null) {
                return;
            }
            $timeout(function () {
                DinghyBoard.query({
                    size: 99,
                    eventId: vm.dinghyEvent.id,
                    fromDate: vm.dinghyEvent.fromDate,
                    untilDate: vm.dinghyEvent.untilDate,
                    sort: ['type,asc', 'id']
                }, function(data) {
                    vm.dinghies = data;
                });
            });
        }

        function dateChanged () {
            var newUntilDate;
            switch (vm.dinghyEvent.type) {
                case 'leisure':
                    if (vm.dinghyEvent.fromDate == null) {
                        return;
                    }
                    if (vm.dinghyEvent.untilDate && vm.dinghyEvent.fromDate < vm.dinghyEvent.untilDate) {
                        newUntilDate = angular.copy(vm.dinghyEvent.untilDate);
                        newUntilDate.setDate(vm.dinghyEvent.fromDate.getDate());
                        newUntilDate.setMonth(vm.dinghyEvent.fromDate.getMonth());
                        newUntilDate.setFullYear(vm.dinghyEvent.fromDate.getFullYear());
                        vm.dinghyEvent.untilDate = newUntilDate;
                    } else {
                        newUntilDate = angular.copy(vm.dinghyEvent.fromDate);
                        newUntilDate.setHours(23);
                    }
                    vm.dinghyEvent.untilDate = newUntilDate;
                    break;
                case 'engagement':
                    if (vm.dinghyEvent.fromDate == null) {
                        return;
                    }
                    if (vm.dinghyEvent.untilDate && vm.dinghyEvent.fromDate < vm.dinghyEvent.untilDate) {
                        newUntilDate = angular.copy(vm.dinghyEvent.untilDate);
                        newUntilDate.setDate(vm.dinghyEvent.fromDate.getDate());
                        newUntilDate.setMonth(vm.dinghyEvent.fromDate.getMonth());
                        newUntilDate.setFullYear(vm.dinghyEvent.fromDate.getFullYear());
                        vm.dinghyEvent.untilDate = newUntilDate;
                    } else {
                        newUntilDate = angular.copy(vm.dinghyEvent.fromDate);
                        newUntilDate.setHours(vm.dinghyEvent.fromDate.getHours() + 4);
                    }
                    vm.dinghyEvent.untilDate = newUntilDate;
                    break;
                case 'regatta':
                case 'training':
                default:
                    break;
            }

            loadAvailableDinghies();

            if(vm.dinghyEvent.fromDate != null) {
                $scope.untilDateOptions = {
                    minDate: new Date(vm.dinghyEvent.fromDate),
                    initDate: new Date(vm.dinghyEvent.fromDate)
                };
                vm.replaceYear();
            }
        }

        function hasPrices() {
            return priceTypes.includes(vm.dinghyEvent.type);
        }

        function replaceYear() {
            if (vm.dinghyEvent.identifier == null) {
                return;
            }
            var replaceYear = vm.dinghyEvent.fromDate.getFullYear();
            var replaceYearTwoDigit = replaceYear.toString().substr(-2);
            vm.dinghyEvent.identifier = vm.dinghyEvent.identifier.replace(replaceYear, '').replace(replaceYearTwoDigit, '');
        }

        function initBulkCreate() {
            vm.showBulkCreateOptions = true;
            vm.activeFromDate = new Date(vm.dinghyEvent.fromDate).setHours(0, 0, 0, 0)
            vm.additionalFromDates.push(vm.activeFromDate);
        }

        function removeSelectedDate (date) {
            vm.additionalFromDates.splice(vm.additionalFromDates.indexOf(date), 1);
        }

        function formIsDirty() {
            return vm.dinghyEvent.id &&
                (vm.oldCanceled !== vm.dinghyEvent.canceled
                || vm.oldName !== vm.dinghyEvent.name
                || vm.oldFromDate !== vm.dinghyEvent.fromDate
                || vm.oldUntilDate !== vm.dinghyEvent.untilDate
                || vm.oldDescription !== vm.dinghyEvent.description
                || vm.oldLocation !== vm.dinghyEvent.location
                || vm.oldGodparent !== vm.dinghyEvent.godparent
                );
        }
    }
})();
